(function() {

    'use strict';

    fsBulkFileActions.$inject = [
        '$location',
        'growl',
        'roleService',
        'fileService',
        'fileDownloadService',
        'sessionStorageService',
        'maximumNumberOfFilesPerAction'
    ];

    function fsBulkFileActions($location,
        growl,
        roleService,
        fileService,
        fileDownloadService,
        sessionStorageService,
        maximumNumberOfFilesPerAction) {
          return {
            restrict: 'A',
            scope: {
                files: '=',
                showBulkDelete: '=?'
            },
            replace: true,
            template: require('./fs-bulk-file-actions.view.html'),
            link: function (scope) {
                scope.downloadDisabled = false;
                scope.bulkActionDisabled = false;
                scope.bulkActionDisabledMessage = 'Limited to ' + maximumNumberOfFilesPerAction + ' files or less';

                if (scope.showBulkDelete === undefined) {
                    scope.showBulkDelete = false;
                }
                scope.isBulkDeleteAllowed = roleService.canBulkDeleteAdministratorFiles() || scope.showBulkDelete;
                scope.canBulkDownloadAllFiles = roleService.canBulkDownloadAllFiles();
                scope.canReassignAllFiles = roleService.canReassignAllFiles();

                scope.$watch('files', function () {
                    var numberOfSelectedItems = scope.files.filter(function (item) {
                        return item.selected === true;
                    }).length;
                    var bulkActionDisabled = numberOfSelectedItems > maximumNumberOfFilesPerAction;
                    if (!scope.bulkActionDisabled && bulkActionDisabled) {
                        growl.error('You cannot download, reassign or delete more than ' + maximumNumberOfFilesPerAction + ' files at once.');
                    }
                    scope.bulkActionDisabled = numberOfSelectedItems > maximumNumberOfFilesPerAction;
                }, true);

                scope.bulkDeleteFiles = function () {
                    if (scope.bulkActionDisabled) return;

                    var files = [];
                    angular.forEach(scope.files, function (file) {
                        if (file.selected === true) {
                            files.push(file);
                        }
                    });
                    scope.$parent.$parent.$broadcast('file-bulk-delete-confirm-dialog', { files: files });
                }

                scope.bulkReassignFiles = function () {
                    if (scope.bulkActionDisabled) return;

                    var selectedFiles = [];
                    angular.forEach(scope.files, function (file) {
                        if (file.selected === true) {
                            selectedFiles.push(file);
                        }
                    });

                    fileService.selectedFiles = selectedFiles;
                    var firmId = sessionStorageService.getItem('firmId');
                    $location.url('/' + firmId + '/files/reassign');
                }

                scope.bulkDownloadFiles = function () {
                    if (scope.bulkActionDisabled) return;

                    scope.downloadDisabled = true;

                    downloadZip()
                        .then(function () {
                            scope.downloadDisabled = false;
                        });
                }

                function downloadZip() {
                    var files = scope.files;
                    var selectedFiles = [];
                    var selectedFileIds = [];

                    angular.forEach(files, function (file) {
                        if (file.selected === true) {
                            selectedFiles.push(file);
                            selectedFileIds.push(file.id);
                        }
                    });

                    var firmId = sessionStorageService.getItem('firmId');

                    return fileDownloadService.downloadZip(firmId, selectedFileIds)
                        .then(function () {

                            angular.forEach(selectedFiles, function (file) {
                                if (file.isAssignedToAllUsers === true) {
                                    file.downloadCount++;
                                } else {
                                    if (file.assignedToEmail === scope.$root.userProfile.currentUser.username) {
                                        file.downloadCount++;
                                    }
                                }
                            });

                        });
                }
            }
        }
    };

    module.exports = fsBulkFileActions;

})();